import { initTracker } from '@/tracking';

initTracker(window.env.MIXPANEL_PROJECT_TOKEN, {
  ignore_dnt: true,
  api_host: window.env.MIXPANEL_PROXY_URL,
});
